import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AuthProject } from '../../../core/auth/models/user';
import { AuthService } from '../../../core/auth/services/auth.service';
import { Store } from '@ngxs/store';
import { AuthState } from '../../../core/auth/store/auth.state';

@Component({
  selector: 'app-project-selector',
  standalone: false,
  templateUrl: './project-selector.component.html',
  styleUrls: ['./project-selector.component.scss']
})
export class ProjectSelectorComponent implements OnInit, OnChanges {
  @Input() selectedProjectId: string | null = null;
  @Input() label: string = 'COMMON.PROJECT';
  @Input() placeholder: string = 'COMMON.SELECT_PROJECT_PLACEHOLDER';
  @Input() headerText: string = 'COMMON.SELECT_PROJECT_PLACEHOLDER';
  @Input() autoSelectFirst: boolean = false;
  @Input() projects: AuthProject[] = [];

  @Output() projectChanged = new EventEmitter<AuthProject | null>();

  hasProjects: boolean = false;

  constructor(private authService: AuthService, private store: Store) {}

  ngOnInit(): void {
    this.loadProjects();
    if(!this.selectedProjectId){
      this.selectedProjectId = this.store.selectSnapshot(AuthState.getSelectedProject).id;
    }
    this.authService.projectChanged.subscribe((changed: boolean)=>{
      this.selectedProjectId = this.store.selectSnapshot(AuthState.getSelectedProject).id;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projects']) {
      this.loadProjects();
    }
    if (changes['selectedProjectId'] && this.projects.length > 0) {
      this.validateSelectedProject();
    }
  }

  private loadProjects(): void {
    // this.projects = this.authService.getUserProjects();
    this.hasProjects = this.projects.length > 0;

    if (this.hasProjects) {
      this.validateSelectedProject();

      // Auto-select first project if none selected and autoSelectFirst is true
      if (!this.selectedProjectId && this.autoSelectFirst) {
        this.selectProject(this.projects[0]);
      }
    }
  }

  private validateSelectedProject(): void {
    if (this.selectedProjectId && !this.projects.find(p => p.id === this.selectedProjectId)) {
      // Selected project no longer exists, clear selection
      this.selectedProjectId = null;
    }
  }

  private selectProject(project: AuthProject): void {
    this.selectedProjectId = project.id;
    this.projectChanged.emit(project);
  }

  handleChange(event: CustomEvent): void {
    const selectedId = event.detail.value;

    if (!selectedId) {
      // No project selected
      this.selectedProjectId = null;
      this.projectChanged.emit(null);
      return;
    }

    const selectedProject = this.projects.find(p => p.id === selectedId);

    if (selectedProject) {
      this.selectProject(selectedProject);
    }
  }
}
